<div class="grid-checkbox ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper" [class.ag-checked]="checked" role="presentation">
	<input class="ag-input-field-input ag-checkbox-input" type="checkbox" />
</div>
